import { Grid as MatchboxGrid } from '@sparkpost/matchbox';

/**
 * Matchbox Grid component
 * @deprecated - Use `Columns` instead
 * @see https://design.sparkpost.com/components/grid/
 */
export default MatchboxGrid;
